export const LOCATIONS = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Canada",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Israel",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "Washington DC",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
]

export const HEIGHTS = {
    59: "Under 5'0",
    60: "5'0",
    61: "5'1",
    62: "5'2",
    63: "5'3",
    64: "5'4",
    65: "5'5",
    66: "5'6",
    67: "5'7",
    68: "5'8",
    69: "5'9",
    70: "5'10",
    71: "5'11",
    72: "6'0",
    73: "6'1",
    74: "6'2",
    75: "6'3",
    76: "6'4",
    77: "6'5",
    78: "Over 6'5",
}

export const CHARACTERISTICS = [
  'Adventurous',
  'Ambitious',
  'Brave',
  'Chiller',
  'Compassionate',
  'Friendly',
  'Funny',
  'Giving',
  'Hard-working',
  'Honest',
  'Humble',
  'Independent',
  'Intellectually Inclined',
  'Leader',
  'Loyal',
  'Open-Minded',
  'Passionate',
  'Quirky',
  'Selfless',
  'Smart',
  'Thoughtful'
]

export const AGES = [ 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65 ];

export const ACTIVITIES = [
  'Acting',
  'Art',
  'Baking',
  'Board Games',
  'Coding',
  'Cooking',
  'Dancing',
  'Gardening',
  'Going for Walks',
  'Going for a Run',
  'Going to Concerts',
  'Going to Museums',
  'Going to Parties/Bars',
  'Hiking',
  'Individual Sports (EX: Tennis, Golf…)',
  'Listening to Music',
  'Listening to Podcasts',
  'Movies',
  'Photography',
  'Playing an Instrument',
  'Puzzles',
  'Reading',
  'Singing',
  'TV',
  'Team Sports(EX: Basketball, Baseball, Football)',
  'Traveling',
  'Video Games',
  'Watching Sports',
  'Water Sports(EX: Swimming, Water Polo)',
  'Winter Sports(EXL Skiing, Snowboarding)',
  'Working Out',
  'Yoga',
]

export const QUANTITY = [
  '0',
  '1-2',
  '3-6',
  '7+',
]

export const PERIOD = [
  'DATE(S)',
]

export const REASONS = [
  'Spoke and decided not to date',
  'I reached out and they did not respond',
  'Neither side reached out'
]

export const COMMUNITY = [
  'UWS',
  'UES',
  'Downtown NY',
  'Washington Heights',
  'Other'
]

export const STYLES = {
    input: (provided, state) => ({
        ...provided,
        color: "white",
    }),
    option: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "#1b1d21"
      },
      backgroundColor: state.isSelected ? "#1f2937" : "#141017",
      fontWeight: state.isSelected ? "bold" : "normal",
      color: "white",
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#141017",
      border: 0,
      boxShadow: 'none',
      // height: '30px'
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "#141017",
      color: "white",
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: 'white',
        fontWeight: 'bold'
    })
}